module.exports = __webpack_public_path__ + "static/Hyundai_Wia-5f733e20c65c17859b82c5c1e5302bae.png";